import React, { Component, Fragment } from "react";
import { Link, withRouter } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import {
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  TextField,
  Button,
  Typography,
  Fab,
  Chip,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import SmsIcon from "@material-ui/icons/Sms";
import SmsFailedIcon from "@material-ui/icons/SmsFailed";
import AlternateEmailIcon from "@material-ui/icons/AlternateEmail";

import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
// import Button from "react-bootstrap/Button";
import moment from "moment";
import SweetAlert from "react-bootstrap-sweetalert";
import axios from "axios";
import { API_ROOT, API_HOST } from "./utils/api-config";
import { ListGroup } from "react-bootstrap";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
}));

const ShowFulfillment = ({ fulfillment, edit }) => {
  const classes = useStyles();

  return (
    <Form>
      <Typography gutterBottom variant="h5" component="h2">
        {fulfillment.name} - {fulfillment.order_number}
      </Typography>

      <Fab color="secondary" onClick={edit} aria-label="edit">
        <EditIcon />
      </Fab>
      {fulfillment.cancelled && (
        <Chip label={"Cancelled"} clickable color={"secondary"} />
      )}

      {fulfillment.created_by && (
        <Chip
          label={`Created by ${fulfillment.created_by}`}
          clickable
          color="primary"
          component={Link}
          to={`/users/${fulfillment.created_by}`}
          clickable
        />
      )}
      <Chip
        label={fulfillment.pickup ? "Return" : "Delivery"}
        clickable
        color={fulfillment.pickup ? "secondary" : "primary"}
      />

      <Chip
        icon={
          fulfillment.phone_status == "delivered" ? (
            <SmsIcon />
          ) : (
            <SmsFailedIcon />
          )
        }
        label={fulfillment.phone_status ? fulfillment.phone_status : "No phone"}
        color={
          fulfillment.phone_status == "delivered" ? "primary" : "secondary"
        }
      />
      <Chip
        icon={<AlternateEmailIcon />}
        label={fulfillment.email_status ? fulfillment.email_status : "No email"}
        color={fulfillment.email_status == "failed" ? "secondary" : "primary"}
      />
      {fulfillment.order_status_url && (
        <Chip
          label="Shopify Status"
          component="a"
          target="_blank"
          href={fulfillment.order_status_url}
          clickable
          color={"secondary"}
        />
      )}

      <Card className={classes.root}>
        <CardActionArea>
          <CardContent>
            <Typography variant="button" display="block" gutterBottom>
              Ship From
            </Typography>
            <Typography variant="caption" display="block" gutterBottom>
              {fulfillment.pickup ? "Customer" : "Merchant"}
            </Typography>
            <Typography gutterBottom variant="h5" component="h2">
              {fulfillment.shipfrom_name}{" "}
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              {fulfillment.shipfrom_email} {fulfillment.shipfrom_phone}
            </Typography>
            <Typography variant="caption" display="block" gutterBottom>
              Address
            </Typography>

            <Typography gutterBottom variant="h5" component="h5">
              {fulfillment.shipfrom_address1 +
                " " +
                (fulfillment.shipfrom_address2
                  ? fulfillment.shipfrom_address2
                  : "") +
                " " +
                fulfillment.shipfrom_city +
                " " +
                fulfillment.shipfrom_zip}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
      <Card className={classes.root}>
        <CardActionArea>
          <CardContent>
            <Typography variant="button" display="block" gutterBottom>
              Ship To
            </Typography>
            <Typography variant="caption" display="block" gutterBottom>
              {!fulfillment.pickup ? "Customer" : "Merchant"}
            </Typography>
            <Typography gutterBottom variant="h5" component="h2">
              {fulfillment.shipto_first_name} {fulfillment.shipto_last_name}
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              {fulfillment.shipto_email} {fulfillment.shipto_phone}
            </Typography>
            <Typography variant="caption" display="block" gutterBottom>
              Address
            </Typography>

            <Typography gutterBottom variant="h5" component="h5">
              {fulfillment.shipto_address1 +
                " " +
                (fulfillment.shipto_address2
                  ? fulfillment.shipto_address2
                  : "") +
                " " +
                fulfillment.shipto_city +
                " " +
                fulfillment.shipto_zip}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
      <Card className={classes.root}>
        <CardActionArea>
          <CardContent>
            <Typography variant="button" display="block" gutterBottom>
              Info
            </Typography>
            <Fragment>
              <Typography variant="caption" display="block" gutterBottom>
                Created
              </Typography>
              <Typography gutterBottom variant="h5" component="h2">
                {fulfillment.created_at}
              </Typography>
            </Fragment>
            {fulfillment.total_price && (
              <Fragment>
                <Typography variant="caption" display="block" gutterBottom>
                  Total price
                </Typography>
                <Typography gutterBottom variant="h5" component="h2">
                  {fulfillment.total_price}
                </Typography>
              </Fragment>
            )}
            {fulfillment.delivery_price && (
              <Fragment>
                <Typography variant="caption" display="block" gutterBottom>
                  Delivery price
                </Typography>
                <Typography gutterBottom variant="h5" component="h2">
                  {fulfillment.delivery_price}
                </Typography>
              </Fragment>
            )}
            {fulfillment.number_of_bags && (
              <Fragment>
                <Typography variant="caption" display="block" gutterBottom>
                  Number of Bags
                </Typography>
                <Typography gutterBottom variant="h5" component="h2">
                  {fulfillment.number_of_bags}
                </Typography>
              </Fragment>
            )}
          </CardContent>
        </CardActionArea>
      </Card>
      {(fulfillment.ordered_items || fulfillment.line_items) && (
        <Card className={classes.root}>
          <CardActionArea>
            <CardContent>
              <Typography variant="button" display="block" gutterBottom>
                Ordered Items
              </Typography>
              {fulfillment.ordered_items.length > 0 &&
                fulfillment.ordered_items.map((item, i) => (
                  <div key={item.id}>
                    {i + 1}
                    {". "}
                    <span className="font-weight-bold">Name:</span> {item.title}{" "}
                    <span className="font-weight-bold">Sku:</span> {item.sku}{" "}
                    <span className="font-weight-bold">Quantity:</span>{" "}
                    {item.quantity}{" "}
                    <span className="font-weight-bold">Price:</span>{" "}
                    {item.price}{" "}
                    <span className="font-weight-bold">Weight:</span>{" "}
                    {item.grams} grams
                  </div>
                ))}
              {fulfillment.line_items.length > 0 &&
                fulfillment.line_items.map((item, i) => (
                  <ListGroup>
                    <ListGroup.Item
                      key={item.id}
                      variant={item.fulfillment_status ? "success" : "danger"}
                    >
                      {i + 1}
                      {". "}
                      <span className="font-weight-bold">Name:</span>{" "}
                      {item.title}{" "}
                      <span className="font-weight-bold">Sku:</span> {item.sku}{" "}
                      <span className="font-weight-bold">Quantity:</span>{" "}
                      {item.quantity}{" "}
                      <span className="font-weight-bold">Price:</span>{" "}
                      {item.price}{" "}
                      <span className="font-weight-bold">Weight:</span>{" "}
                      {item.grams} grams
                    </ListGroup.Item>
                  </ListGroup>
                ))}
            </CardContent>
          </CardActionArea>
        </Card>
      )}
      <Form.Row>
        {fulfillment.number_of_bags && (
          <Form.Group as={Col} controlId="formGridBags">
            <Form.Label>Number of Bags/Boxes</Form.Label>
            <Form.Control
              readOnly
              value={fulfillment.number_of_bags}
              name="number_of_bags"
            />
          </Form.Group>
        )}
        {/* <Form.Group as={Col} controlId="formGridPrice">
            <Form.Label>Delivery Price</Form.Label>
            <Form.Control
              readOnly
              value={
                fulfillment.delivery_price ? fulfillment.delivery_price : ""
              }
              name="price"
            />
          </Form.Group> */}
      </Form.Row>
      {/* <Form.Row>
        {fulfillment.retailers_notes && (
          <Form.Group as={Col} controlId="formGridInstructions">
            <Form.Label>Retailers Notes</Form.Label>
            <Form.Control
              readOnly
              value={fulfillment.retailers_notes}
              name="retailers_notes"
            />
          </Form.Group>
        )}
        {fulfillment.fulfillment_notes && (
          <Form.Group as={Col} controlId="formGridNotes">
            <Form.Label>fulfillment Notes</Form.Label>
            <Form.Control
              readOnly
              value={fulfillment.retailers_notes}
              name="fulfillment_notes"
            />
          </Form.Group>
        )}
      </Form.Row> */}
      {fulfillment.order_notes &&
        fulfillment.order_notes.map((note, i) => (
          <Form.Row key={i}>
            <Form.Group as={Col} controlId={`formGridNote${i}`}>
              <Form.Label>
                Note Added by {fulfillment.order_notes_by[i]} on{" "}
                {moment(fulfillment.order_notes_times[i]).format(
                  "MMMM Do YYYY, h:mm:ss a"
                )}
              </Form.Label>
              <Form.Control
                value={fulfillment.order_notes[i]}
                name="retailers_notes"
                readOnly
              />
            </Form.Group>
          </Form.Row>
        ))}
      {fulfillment.cancelled && (
        <Form.Row>
          <Form.Group as={Col} controlId="formGridCancelled">
            <Form.Label>Cancelled</Form.Label>
            <Form.Check
              readOnly
              checked={fulfillment.cancelled}
              name="cancelled"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridCancelledAt">
            <Form.Label>Cancelled At</Form.Label>
            <Form.Control
              readOnly
              value={
                fulfillment.cancelled_at
                  ? moment(fulfillment.cancelled_at).format("MMM DD, hh:mm a")
                  : ""
              }
              name="cancelled_at"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridCancelledBy">
            <Form.Label>Cancelled By</Form.Label>
            <Form.Control
              readOnly
              value={fulfillment.cancelled_by ? fulfillment.cancelled_by : ""}
              name="cancelled_by"
            />
          </Form.Group>
        </Form.Row>
      )}
      <Col md="3">
        {/* <Form.Row>
          <Form.Group controlId="formDelete">
            <Form.Label>
              <h4 className="mb-10">DELETE FULFILLMENT</h4>
            </Form.Label>
          </Form.Group>
        </Form.Row> */}
        {/* {this.state.showDelete && (
          <SweetAlert
            type="danger"
            title="You are going to delete the fulfillment!"
            onConfirm={() => this.handleDelete(fulfillment.id)}
            onCancel={this.hideDeleteAlert}
            showCancel={true}
            confirmBtnText="Delete"
            confirmBtnBsStyle="danger"
            closeAnim={{
              name: "hideSweetAlert",
              duration: 100,
            }}
          />
        )} */}
        {/* <Button
          variant="danger"
          onClick={() => this.setState({ showDelete: true })}
        >
          Delete
        </Button> */}
        {/* {this.state.showPickups && (
          <SweetAlert
            type="success"
            title="Pickup tasks completed"
            onConfirm={this.hidePickupsAlert}
            showCancel={false}
            confirmBtnText="OK"
            confirmBtnBsStyle="success"
            closeAnim={{
              name: "hideSweetAlert",
              duration: 100,
            }}
          />
        )} */}
      </Col>
    </Form>
  );
};

export default withRouter(ShowFulfillment);
